const $$splitComponentImporter = () => import('/app/src/routes/dashboard/therapist/finances.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/therapist/finances")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type Tab = "earnings" | "payouts" | "invoices";
interface SessionRow {
  id: string;
  scheduledAt: string;
  clientName: string;
  serviceName: string | null;
  therapistEarnings: number | null;
  paymentStatus: string;
  payoutId: string | null;
  payoutPaidAt: string | null;
}
interface MonthlyPoint {
  month: string;
  earnings: number;
  sessions: number;
}
interface EarningsResponse {
  summary: {
    totalEarnings: number;
    pendingPayout: number;
    paidOut: number;
    sessionCount: number;
  };
  sessions: SessionRow[];
  monthly: MonthlyPoint[];
  range: {
    from: string | null;
    to: string | null;
  };
}
interface SubscriptionInvoiceRow {
  id: string;
  receiptNumber: string | null;
  planType: "semiannual" | "annual" | "custom";
  amountNet: number;
  amountVat: number;
  amountGross: number;
  currency: string;
  periodStart: string | null;
  periodEnd: string | null;
  paymentMethod: "monri" | "bank_transfer" | "manual";
  status: "completed";
  completedAt: string | null;
  createdAt: string;
}
interface SubscriptionLedgerResponse {
  rows: SubscriptionInvoiceRow[];
  totalPaid: number;
}